import "./index.css";
import { sheetRows } from "./sheet";

/**
 * The paper face: the same week as a plain printed grid.
 * Rendered for print only; nothing renders it on screen.
 */
function Paper(props) {
  const { slots, weekdayFormat, showWeekdays, title, shouldPrintHeader, className = "" } = props;
  const rows = sheetRows(props);

  return (
    <div className={`Paper ${className}`.trim()} data-weekdays={showWeekdays ? weekdayFormat : undefined}>
      {shouldPrintHeader && title ? <h2 className="Paper-title">{title}</h2> : null}
      <table className="Paper-grid">
        <thead>
          <tr>
            <th scope="col" className="Paper-date">
              Date
            </th>
            {slots.map((slot) => (
              <th scope="col" key={slot.id}>
                {slot.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => {
            return (
              <tr key={row.key}>
                <th scope="row" className="Paper-date">
                  {row.label}
                </th>
                {slots.map((slot, i) => {
                  const done = row.done[i];
                  return (
                    <td key={slot.id}>
                      <span className={`Paper-box${done ? " is-done" : ""}`} aria-hidden="true">
                        {done ? (
                          <svg
                            viewBox="0 0 24 24"
                            width="12"
                            height="12"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M5 12.5l4.5 4.5L19 7.5" />
                          </svg>
                        ) : null}
                      </span>
                      {/* The name is printed once, in the header this cell sits
                          under, and `thead` repeats on every page. Repeating it in
                          every cell said nothing new and cost the checkbox most of
                          its column: at eight columns the label had 9.2mm and was
                          cut to "New…", while the box it belongs to had 4.2mm. */}
                      <span className="sr-only">{`${slot.name} — ${done ? "done" : "not done"}`}</span>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Paper;
